export default __webpack_public_path__ + "static/media/UNISON-logo-blue.4a2a2d9b.svg";